// Notificaciones de escritorio del navegador para pedidos nuevos cuando la pestaña
// del panel está en SEGUNDO PLANO (el comercio cambió de tab/ventana). Es un refuerzo
// opcional de la alarma sonora + el NotificationCenter in-app: opt-in (requiere permiso
// del usuario) y a prueba de fallos — NUNCA debe romper la recepción de pedidos.

const isSupported = () => typeof window !== 'undefined' && 'Notification' in window;

let permissionRequested = false;

// Solicita el permiso de notificaciones UNA sola vez. Debe llamarse desde un gesto del
// usuario (click/touch) para que el navegador no bloquee el prompt. Idempotente.
export const ensureOrderNotifyPermission = (): void => {
  try {
    if (!isSupported() || permissionRequested) return;
    permissionRequested = true;
    if (Notification.permission !== 'default') return; // ya concedido o denegado
    Notification.requestPermission().catch(() => undefined);
  } catch {
    /* nunca romper por el permiso */
  }
};

// Dispara una notificación de escritorio si — y solo si — la pestaña está oculta y el
// usuario ya concedió permiso. Al hacer click, enfoca de vuelta la ventana del panel.
export const notifyNewOrder = (params: { title: string; body: string }): void => {
  try {
    if (!isSupported() || Notification.permission !== 'granted') return;
    if (typeof document !== 'undefined' && document.visibilityState !== 'hidden') return;
    // tag fijo: si entran varios pedidos seguidos en background, se reemplaza la
    // notificación viva en vez de apilar decenas.
    const notification = new Notification(params.title, {
      body: params.body,
      tag: 'plick-new-order',
    });
    notification.onclick = () => {
      try {
        window.focus();
        notification.close();
      } catch {
        /* noop */
      }
    };
  } catch {
    /* nunca romper la recepción de pedidos */
  }
};
